'use client'

import Heart from '@/app/_components/sections/hero/svgs/Heart'
import ThreeStar from '@/app/_components/sections/hero/svgs/ThreeStar'
import BigStar from '@/components/svgs/BigStarSvg/BigStar'
import Plane from '@/components/svgs/Plane'
import ThreeStars from '@/components/svgs/ThreeStarsSvg/threeStars'
import { Button, Center, Stack, Text, Title } from '@mantine/core'
import { IconSearch } from '@tabler/icons-react'
import Link from 'next/link'

export default function NotFoundPage() {
	return (
		<div className="relative min-h-[80vh] flex justify-center items-center">
			{/* Decorative elements */}
			<Heart className="absolute right-8 bottom-4 w-[16%] lg:left-24 lg:bottom-44 lg:w-[8%] -rotate-12 animate-fade-in-move-right" />
			<Heart className="absolute right-28 bottom-20 w-[10%] lg:left-52 lg:bottom-28 z-10 lg:w-[7%] rotate-[30deg] animate-fade-in-move-right" />
			<ThreeStars className="hidden lg:block absolute top-10 right-10 z-50 w-[8%] rotate-[-40deg] scale-105 fill-background animate-fade-in-move-right" />
			<ThreeStar className="absolute w-[22%] top-0 left-10 lg:top-0 lg:left-20 z-[10] lg:w-[10%] rotate-[50deg] animate-fade-in-move-right fill-background" />
			<Plane className="absolute mx-auto left-0 right-0 top-[100px] lg:top-[50px] xl:-top-[80px] w-[300px] lg:w-[500px] xl:w-[600px] -rotate-[28deg] animate-fade-in z-[-100]" />
			<BigStar className="absolute animate-fade-in-move-left bottom-44 w-[100px] -right-10 lg:right-10 lg:w-[150px] xl:w-[250px] z-[-100]" />

			{/* Content */}
			<Stack align="center" justify="center" gap="lg" className="z-10 max-w-xl p-8">
				<Center>
					<IconSearch size={80} color="#814256" stroke={1.5} />
				</Center>

				<Title className="font-patrick text-center text-wine">Página não encontrada</Title>

				<Text size="lg" ta="center">
					Ops! A página que você está procurando não existe.
				</Text>

				<Text c="dimmed" ta="center">
					O endereço pode ter sido digitado incorretamente ou a página pode ter sido movida.
				</Text>

				<Link href="/">
					<Button variant="outline" size="md">
						Voltar para a página inicial
					</Button>
				</Link>
			</Stack>
		</div>
	)
}
